import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ProductSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ProductSVG;
